import { createUseStyles } from "react-jss";

export default createUseStyles ( theme => {
	return {
		emptyContainer: {
			display        : "flex",
			alignItems     : "center",
			justifyContent : "center",
			margin         : "3rem 0"
		},
		textContainer: {
			textAlign     : "center",
			display       : "flex",
			flexDirection : "column",
			alignItems    : "center"
		},
		iconStyle: {

		},
		textStyles: {
			color      : "#757575 !important",
			fontWeight : "bold",
			fontSize   : "1rem !important"
		}
	};
} );
